import { commonAttributes, tableColumnDefaultOption } from 'app/config'
import { validateNotEmpty } from 'app/validators'

export const columns = [
  { ...commonAttributes.uuid },
  {
    name: 'key',
    label: 'Key',
    validate: validateNotEmpty,
    ...tableColumnDefaultOption
  },
  {
    name: 'label',
    label: 'Label',
    validate: validateNotEmpty,
    ...tableColumnDefaultOption
  },
  { name: 'icon', label: 'Icon', optional: true, ...tableColumnDefaultOption },
  { name: 'is_default', label: 'Default', ...tableColumnDefaultOption },
  { name: 'is_active', label: 'Active', ...tableColumnDefaultOption }
]
